const middleware = {}

middleware['redirect-www'] = require('../middleware/redirect-www.js')
middleware['redirect-www'] = middleware['redirect-www'].default || middleware['redirect-www']

middleware['redirects'] = require('../middleware/redirects.js')
middleware['redirects'] = middleware['redirects'].default || middleware['redirects']

export default middleware
